import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import authService from "../services/auth";
import { buildAuthLink } from "../utils/navigation";
import { ROUTES } from "../config/constants";

// isAuthenticated() is a pure predicate — safe to call during render.
// Backend always verifies tokens — client-side check is a UX optimisation only.
export function ProtectedRoute({ children, requiredRole }) {
  const location = useLocation();

  if (!authService.isAuthenticated()) {
    // Full cleanup on every unauthenticated access: removes any expired token
    // and flushes the inflight request cache so stale entries are never
    // forwarded on the next authenticated request.  Safe to call when no token
    // is present — localStorage.removeItem on a missing key is a no-op.
    authService.clearLocalAuth();
    const returnTo = location.pathname + location.search;
    return <Navigate to={buildAuthLink(ROUTES.LOGIN, returnTo)} replace />;
  }

  // Optional role check (server enforces via requireRole; client check is UX optimization)
  if (requiredRole) {
    const user = authService.getCurrentUser();
    if (user?.role !== requiredRole) {
      return <Navigate to={ROUTES.AUTHENTICATED_HOME} replace />;
    }
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredRole: PropTypes.string,
};
